import { BatonLogo } from "@baton/brand";
import { useI18n } from "@baton/i18n";
import "./outside-shell.css";

/**
 * The product's logo at the head of a work sheet drawn with no rail beside it: a screen outside the
 * workspace shell (`OutsideShell`) and the shell's no-access sheet, which carry no other mark of the
 * product, so the logo is named as the screen's one brand text (2026-09-28, by the owner's
 * decision: "use the logos everywhere in the platform"; `contracts/design-system.md` § Brand).
 */
export function SheetLogo() {
  const { t } = useI18n();
  return (
    <div className="b-sheet-logo">
      <BatonLogo label={t("app.name")} className="b-sheet-logo__mark" />
    </div>
  );
}
